export {default} from './thrustcurve-db.json';
